export const GUID_REGEXP = /[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}/;

export const ADDRESS_FULL_FLAT_REGEXP = /,\s*кв.*$/;

export const ADDRESS_FLAT_REGEXP = /,\s?кв\.?\s?/;
export const ADDRESS_POSTAL_CODE_REGEXP = /^\d{6},*\s/;
